import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faBell } from '@fortawesome/pro-light-svg-icons';

export type ProLightBellProps = IconComponentProps;

export const ProLightBell = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightBellProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faBell}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faBell}
    />
  );
};

ProLightBell.displayName = 'ProLightBell';
